import { numberInputClasses } from "@mui/base"
import { PurchaseState } from "../interfaces/purchase"
import { Types } from "../types"
import { PurchaseActions } from "../types/Purchase/actionsType"

const initialState: PurchaseState = {
    selectPackagePending: false,
    selectPackageSuccess: false,
    selectPackageError: null,
    getCandidateIVRPending: false,
    getCandidateIVRSuccess: false,
    getCandidateIVRError: null,
    getCandidateSecretaryPending: false,
    getCandidateSecretarySuccess: false,
    getCandidateSecretaryError: null,
    getCandidateFaxPending: false,
    getCandidateFaxSuccess: false,
    getCandidateFaxError: null,
    ivrPackages: [],
    getProductNumbersCountPending: false,
    getProductNumbersCountSuccess: false,
    getProductNumbersCountError: null,
    packageNumbersCount: undefined,
    secretaryPackages: [],
    faxPackages: [],
    resultLines: null,
    searchFreeProposedNumbersResult: null,
    searchFreeProposedNumbersPending: false,
    getProposedNumbersResult: null,
    getProposedNumbersPending: false,
    searchProposedNumbersPending: false,
    getCitiesResult: null,
    getProposedNumbersError: "",
    getApplicationContractTypePending: false,
    applicationContractType: null,
    htmlPreInvoiceToCustomer: undefined,
    getHtmlPreInvoiceToCustomerPending: false,
    gatewayPrepareResult: undefined,
    postTryReserveRequestedLinesResult: undefined,
    postTryReserveRequestedLinesPending: false,
    getHtmlPreInvoiceToCustomerError: undefined,
    postPurchaseBuySuccess: false,
    purchaseInfo: undefined,
    postPurchaseBuyError: "",
    getPurchaseInfoPending: false,
    postPurchaseBuyPending: false,
    getPurchaseInfoResult: undefined,
    genHtmlPINRCResult: undefined,
    genHtmlPINRCPending: false,
    genHtmlPINRCError: undefined
}


const purchaseReducer = (state = initialState, action: PurchaseActions, response: any) => {

    switch (action.type) {
        case Types.SELECT_PACKAGE_REQUEST:
            return {
                ...state,
                selectPackagePending: true,
                selectPackageSuccess: false,
                selectPackageError: null,
                // resultLines: []
            }
        case Types.SELECT_PACKAGE_SUCCESS:

            return {
                ...state,
                selectPackagePending: false,
                selectPackageSuccess: true,
                selectPackageError: null,
                resultLines: action.response
            }

        case Types.SELECT_PACKAGE_ERROR:

            return {
                ...state,
                selectPackagePending: false,
                selectPackageSuccess: false,
                selectPackageError: action.payload
            }


        case Types.GET_CANDIDATE_IVR_PRODUCT_REQUEST:

            return {
                ...state,
                getCandidateIVRPending: true,
                getCandidateIVRSuccess: false,
                getCandidateIVRError: null,
                ivrPackages: null

            }
        case Types.GET_CANDIDATE_IVR_PRODUCT_SUCCESS:

            return {
                ...state,
                getCandidateIVRPending: false,
                getCandidateIVRSuccess: true,
                getCandidateIVRError: null,
                ivrPackages: action.response

            }

        case Types.GET_CANDIDATE_IVR_PRODUCT_ERROR:

            return {
                ...state,
                getCandidateIVRPending: false,
                getCandidateIVRSuccess: false,
                getCandidateIVRError: action.payload
            }

        case Types.GET_CANDIDATE_SECRETARY_PRODUCT_REQUEST:

            return {
                ...state,
                getCandidateSecretaryPending: true,
                getCandidateSecretarySuccess: false,
                getCandidateSecretaryError: null,
                secretaryPackages: []

            }
        case Types.GET_CANDIDATE_SECRETARY_PRODUCT_SUCCESS:

            return {
                ...state,
                getCandidateSecretaryPending: false,
                getCandidateSecretarySuccess: true,
                getCandidateSecretaryError: null,
                secretaryPackages: action.response

            }

        case Types.GET_CANDIDATE_SECRETARY_PRODUCT_ERROR:

            return {
                ...state,
                getCandidateSecretaryPending: false,
                getCandidateSecretarySuccess: false,
                getCandidateSecretaryError: action.payload
            }


        case Types.GET_CANDIDATE_FAX_PRODUCT_REQUEST:

            return {
                ...state,
                getCandidateFaxPending: true,
                getCandidateFaxSuccess: false,
                getCandidateFaxError: null,
                faxPackages: null

            }
        case Types.GET_CANDIDATE_FAX_PRODUCT_SUCCESS:

            return {
                ...state,
                getCandidateFaxPending: false,
                getCandidateFaxSuccess: true,
                getCandidateFaxError: null,
                faxPackages: action.response

            }

        case Types.GET_CANDIDATE_FAX_PRODUCT_ERROR:

            return {
                ...state,
                getCandidateFaxPending: false,
                getCandidateFaxSuccess: false,
                getCandidateFaxError: action.payload
            }


        case Types.GET_PRODUCT_NUMBERS_COUNT_REQUEST:

            return {
                ...state,
                getProductNumbersCountPending: true,
                getProductNumbersCountSuccess: false,
                getProductNumbersCountError: null,


            }
        case Types.GET_PRODUCT_NUMBERS_COUNT_SUCCESS:

            return {
                ...state,
                getProductNumbersCountPending: false,
                getProductNumbersCountSuccess: true,
                getProductNumbersCountError: null,
                packageNumbersCount: action.response


            }

        case Types.GET_PRODUCT_NUMBERS_COUNT_ERROR:

            return {
                ...state,
                getProductNumbersCountPending: false,
                getProductNumbersCountSuccess: false,
                getProductNumbersCountError: action.payload
            }


        case Types.GET_APPLICATION_CONTRACT_TYPE_REQUEST:
            return {
                ...state,
                getApplicationContractTypePending: true,
                getApplicationContractTypeSuccess: false,
                getApplicationContractTypeError: null,
                applicationContractType: null


            }
        case Types.GET_APPLICATION_CONTRACT_TYPE_SUCCESS:

            return {
                ...state,
                getApplicationContractTypePending: false,
                getApplicationContractTypeSuccess: true,
                getApplicationContractTypeError: null,
                applicationContractType: action.response


            }

        case Types.GET_APPLICATION_CONTRACT_TYPE_ERROR:

            return {
                ...state,
                getApplicationContractTypePending: false,
                getApplicationContractTypeSuccess: false,
                getApplicationContractTypeError: action.payload,
                applicationContractType: null
            }



        case Types.GEN_HTML_PRE_INVOICE_TO_CUSTOMER_REQUEST:

            return {
                ...state,
                getHtmlPreInvoiceToCustomerPending: true,
                getHtmlPreInvoiceToCustomerSuccess: false,
                getHtmlPreInvoiceToCustomerError: null,
                // htmlPreInvoiceToCustomer: null


            }
        case Types.GEN_HTML_PRE_INVOICE_TO_CUSTOMER_SUCCESS:
            return {
                ...state,
                getHtmlPreInvoiceToCustomerPending: false,
                getHtmlPreInvoiceToCustomerSuccess: true,
                getHtmlPreInvoiceToCustomerError: null,
                htmlPreInvoiceToCustomer: action.response


            }

        case Types.GEN_HTML_PRE_INVOICE_TO_CUSTOMER_ERROR:

            return {
                ...state,
                getHtmlPreInvoiceToCustomerPending: false,
                getHtmlPreInvoiceToCustomerSuccess: false,
                getHtmlPreInvoiceToCustomerError: action.payload,
                // htmlPreInvoiceToCustomer: null
            }



        case Types.SEARCH_FREE_PROPOSE_NUMBER_REQUEST:

            return {
                ...state,
                searchFreeProposedNumbersPending: true,
                searchFreeProposedNumbersSuccess: false,
                searchFreeProposedNumbersError: null,
                searchFreeProposedNumbersResult: null


            }
        case Types.SEARCH_FREE_PROPOSE_NUMBER_SUCCESS:

            return {
                ...state,
                searchFreeProposedNumbersPending: false,
                searchFreeProposedNumbersSuccess: true,
                searchFreeProposedNumbersError: null,
                searchFreeProposedNumbersResult: action.response


            }

        case Types.SEARCH_FREE_PROPOSE_NUMBER_ERROR:

            return {
                ...state,
                searchFreeProposedNumbersPending: false,
                searchFreeProposedNumbersSuccess: false,
                searchFreeProposedNumbersError: action.payload
            }



        case Types.GET_PREPARE_FOR_GATEWAY_REQUEST:

            return {
                ...state,
                getPrepareForGatewayPending: true,
                getPrepareForGatewaySuccess: false,
                getPrepareForGatewayError: null,


            }
        case Types.GET_PREPARE_FOR_GATEWAY_SUCCESS:

            return {
                ...state,
                // getPrepareForGatewayPending: false,
                getPrepareForGatewaySuccess: true,
                getPrepareForGatewayError: null,
                gatewayPrepareResult: action.response


            }

        case Types.GET_PREPARE_FOR_GATEWAY_ERROR:

            return {
                ...state,
                getPrepareForGatewayPending: false,
                getPrepareForGatewaySuccess: false,
                getPrepareForGatewayError: action.payload
            }



        case Types.POST_TRY_RESERVE_LINE_REQUEST:

            return {
                ...state,
                postTryReserveRequestedLinesPending: true,
                postTryReserveRequestedLinesSuccess: false,
                postTryReserveRequestedLinesError: null,


            }
        case Types.POST_TRY_RESERVE_LINE_SUCCESS:

            return {
                ...state,
                postTryReserveRequestedLinesPending: false,
                postTryReserveRequestedLinesSuccess: true,
                postTryReserveRequestedLinesError: null,
                postTryReserveRequestedLinesResult: action.response


            }

        case Types.POST_TRY_RESERVE_LINE_ERROR:

            return {
                ...state,
                postTryReserveRequestedLinesPending: false,
                postTryReserveRequestedLinesSuccess: false,
                postTryReserveRequestedLinesError: action.payload
            }



        case Types.POST_PURCHASE_BUY_REQUEST:

            return {
                ...state,
                postPurchaseBuyPending: true,
                postPurchaseBuySuccess: false,
                postPurchaseBuyError: null,
                postPurchaseBuyResult: null


            }
        case Types.POST_PURCHASE_BUY_SUCCESS:

            return {
                ...state,
                postPurchaseBuyPending: false,
                postPurchaseBuySuccess: true,
                postPurchaseBuyError: null,
                postPurchaseBuyResult: action.response


            }

        case Types.POST_PURCHASE_BUY_ERROR:

            return {
                ...state,
                postPurchaseBuyPending: false,
                postPurchaseBuySuccess: false,
                postPurchaseBuyError: action.payload
            }



        case Types.GET_PURCHASE_INFO_REQUEST:

            return {
                ...state,
                getPurchaseInfoPending: true,
                getPurchaseInfoSuccess: false,
                getPurchaseInfoError: null,
                getPurchaseInfoResult: null


            }
        case Types.GET_PURCHASE_INFO_SUCCESS:

            return {
                ...state,
                getPurchaseInfoPending: false,
                getPurchaseInfoSuccess: true,
                getPurchaseInfoError: null,
                getPurchaseInfoResult: action.response


            }

        case Types.GET_PURCHASE_INFO_ERROR:

            return {
                ...state,
                getPurchaseInfoPending: false,
                getPurchaseInfoSuccess: false,
                getPurchaseInfoError: action.payload
            }



        case Types.GET_CITIES_REQUEST:

            return {
                ...state,
                getCitiesPending: true,
                getCitiesSuccess: false,
                getCitiesError: null,
                getCitiesResult: null


            }
        case Types.GET_CITIES_SUCCESS:

            return {
                ...state,
                getCitiesPending: false,
                getCitiesSuccess: true,
                getCitiesError: null,
                getCitiesResult: action.response


            }

        case Types.GET_CITIES_ERROR:

            return {
                ...state,
                getCitiesPending: false,
                getCitiesSuccess: false,
                getCitiesError: action.payload
            }



        case Types.GET_PROPOSED_NUMBERS_REQUEST:

            return {
                ...state,
                getProposedNumbersPending: true,
                getProposedNumbersSuccess: false,
                getProposedNumbersError: null,
                // getProposedNumbersResult: null


            }
        case Types.GET_PROPOSED_NUMBERS_SUCCESS:

            return {
                ...state,
                getProposedNumbersPending: false,
                getProposedNumbersSuccess: true,
                getProposedNumbersError: null,
                getProposedNumbersResult: action.response


            }

        case Types.GET_PROPOSED_NUMBERS_ERROR:

            return {
                ...state,
                getProposedNumbersPending: false,
                getProposedNumbersSuccess: false,
                getProposedNumbersError: action.payload
            }



        case Types.SEARCH_PROPOSED_NUMBERS_REQUEST:

            return {
                ...state,
                searchProposedNumbersPending: true,
                searchProposedNumbersSuccess: false,
                searchProposedNumbersError: null,
                // searchProposedNumbersResult: null


            }
        case Types.SEARCH_PROPOSED_NUMBERS_SUCCESS:

            return {
                ...state,
                searchProposedNumbersPending: false,
                searchProposedNumbersSuccess: true,
                searchProposedNumbersError: null,
                getProposedNumbersResult: action.response


            }

        case Types.SEARCH_PROPOSED_NUMBERS_ERROR:

            return {
                ...state,
                searchProposedNumbersPending: false,
                searchProposedNumbersSuccess: false,
                searchProposedNumbersError: action.payload
            }



        case Types.GET_IS_FREE_PRODUCT_REQUEST:

            return {
                ...state,
                getIsFreeProductPending: true,
                getIsFreeProductSuccess: false,
                getIsFreeProductError: null,
                // getIsFreeProductResult: null


            }
        case Types.GET_IS_FREE_PRODUCT_SUCCESS:

            return {
                ...state,
                getIsFreeProductPending: false,
                getIsFreeProductSuccess: true,
                getIsFreeProductError: null,
                getIsFreeProductResult: action.response


            }

        case Types.GET_IS_FREE_PRODUCT_ERROR:

            return {
                ...state,
                getIsFreeProductPending: false,
                getIsFreeProductSuccess: false,
                getIsFreeProductError: action.payload
            }


        case Types.GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_REQUEST:

            return {
                ...state,
                genHtmlPINRCPending: true,
                genHtmlPINRCSuccess: false,
                genHtmlPINRCError: null,
                // genHtmlPINRCResult: null


            }
        case Types.GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_SUCCESS:

            return {
                ...state,
                genHtmlPINRCPending: false,
                genHtmlPINRCSuccess: true,
                genHtmlPINRCError: null,
                genHtmlPINRCResult: action.response


            }

        case Types.GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_ERROR:

            return {
                ...state,
                genHtmlPINRCPending: false,
                genHtmlPINRCSuccess: false,
                genHtmlPINRCError: action.payload
            }

        case Types.RESET_PURCHASE_CREATE_INVOICE_PROPS:

            return {
                ...state,
                genHtmlPINRCResult: undefined,
                getApplicationContractTypePending: false,
                genHtmlPINRCError: null,
                postTryReserveRequestedLinesSuccess: false,
                postTryReserveRequestedLinesPending: false,
                applicationContractType: undefined
            }

        case Types.RESET_INVOICE:

            return {
                ...state,
                htmlPreInvoiceToCustomer: undefined

            }

        case Types.SET_RESET_PURCHASE_PROPS:
            return {
                ...state,
                selectPackagePending: false,
                selectPackageSuccess: false,
                selectPackageError: null,
                getCandidateIVRPending: false,
                getCandidateIVRSuccess: false,
                getCandidateIVRError: null,
                getCandidateSecretaryPending: false,
                getCandidateSecretarySuccess: false,
                getCandidateSecretaryError: null,
                getCandidateFaxPending: false,
                getCandidateFaxSuccess: false,
                getCandidateFaxError: null,
                ivrPackages: null,
                getProductNumbersCountPending: false,
                getProductNumbersCountSuccess: false,
                getProductNumbersCountError: null,
                packageNumbersCount: undefined,
                getHtmlPreInvoiceToCustomerPending: false,
                getHtmlPreInvoiceToCustomerSuccess: false,
                getHtmlPreInvoiceToCustomerError: null,
                getApplicationContractTypePending: false,
                getApplicationContractTypeSuccess: false,
                getApplicationContractTypeError: null,
                applicationContractType: null,
                searchFreeProposedNumbersPending: false,
                searchFreeProposedNumbersSuccess: false,
                searchFreeProposedNumbersError: null,
                // getPrepareForGatewayPending: false,
                getPrepareForGatewaySuccess: false,
                getPrepareForGatewayError: null,
                gatewayPrepareResult: null,
                postPurchaseBuyPending: false,
                postPurchaseBuySuccess: false,
                postPurchaseBuyError: null,
                getPurchaseInfoPending: false,
                getPurchaseInfoSuccess: false,
                getPurchaseInfoError: null,
                getPurchaseInfoResult: null,
                searchProposedNumbersPending: false,
                searchProposedNumbersSuccess: false,
                searchProposedNumbersError: null,
                getProposedNumbersPending: false,
                getProposedNumbersSuccess: false,
                getProposedNumbersError: null,
                getCitiesPending: false,
                getCitiesSuccess: false,
                getCitiesError: null,
                postTryReserveRequestedLinesResult: undefined
            }





        default:
            return {
                ...state
            }
    }
}

export default purchaseReducer